<template>
    <div class="pt-[40px] pb-[56px]">
        <div class="font-bold text-emphas text-[30px] leading-[46px]">{{ $t("RecentActivity") }}</div>
        <div class="text-[16px] leading-[32px]">{{ $t("RecentActivityDesc") }}</div>
        <div class="mt-[24px]">
            <div
                v-for="(value, key) in data"
                class="group pl-[20px] py-[8px] leading-[30px] bg-color7 rounded-[4px] flex items-center [&:not(:first-child)]:mt-[10px] duration-300 transition-bg hover:bg-[#ECE8FA]">
                <span class="font-bold">{{ (key + 1 + (page - 1) * 10).toString().padStart(2, "0") }}</span>
                <span class="pr-[24px] pl-[20px] font-bold">·</span>
                <project-route class="font-bold ellipsis flex-1 text-default visited:text-default" :to="value.url" target="_blank">
                    【{{ value.name }}】{{ value.url }}
                </project-route>
                <span class="px-[20px] duration-300 transition-all">{{ value.date }}</span>
                <div
                    class="bg-main w-[0] h-[0] opacity-0 rounded-[50%] text-white flex items-center justify-center cursor-pointer mr-[15px] duration-300 transition-all group-hover:w-[28px] group-hover:h-[28px] group-hover:opacity-100"
                    @click.stop="methods.delete(value)">
                    <ui-icon class="text-white" name="ashcan" />
                </div>
            </div>
        </div>

        <ui-pagination class="mt-[24px]" v-model="page" :count="count" @change="methods.acquire()">
            <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
        </ui-pagination>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiPagination, UiIcon } from "various-ui";

import { useComposable } from "./src/composable";

const { refs, methods } = useComposable();
const { data, count, page } = refs;

//* 组件挂载时，获取文件夹数据
onMounted(() => methods.acquire());
</script>
